import React from "react";
import { MessageSquare, Package, PhoneCall } from "lucide-react";

type ContractOverviewProps = {
  contractId: string;
  shopName: string;
  status: string;
  metrics?: { title: string; value: number }[];
  chatUp?: any;
};


const ContractOverview: React.FC<ContractOverviewProps> = ({
  contractId,
  shopName,
  status,
  metrics,
  chatUp,
}) => {
  return (
    <div className="bg-white  p-6 rounded-3xl space-y-4">
      {/* Header Section */}
      <div className="flex items-center justify-between gap-4">
        <div className="flex items-center gap-4">
          <h2 className="text-sm md:text-lg font-semibold">
            Contract ID : {contractId}
          </h2>
          {/* Status Section */}
          <div>
            <span
              className={`text-xs px-2 py-1 rounded-md font-semibold ${
                status === "PAID"
                  ? "bg-green-50 text-green-500 border border-green-500"
                  : status === "PENDING"
                  ? "bg-yellow-50 text-yellow-500 border border-yellow-500"
                  : "bg-gray-50 text-gray-500 border-gray-500"
              }`}
            >
              {status}
            </span>
          </div>
        </div>
        {chatUp && (
          <div className="flex gap-4">
            <button className="text-blue-600 hover:text-blue-800 flex items-center">
              <MessageSquare className="w-5 h-5 mr-1" /> Chat admin
            </button>
            <button className="text-blue-600 hover:text-blue-800 flex items-center">
              <PhoneCall className="w-5 h-5 mr-1" /> Call admin
            </button>
          </div>
        )}
      </div>
      <div className="text-sm ">{shopName}</div>

      {/* Metrics Section */}
      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4">
        {metrics?.map((metric, index) => (
          <div
            key={index}
            className="flex items-center gap-4 bg-gray-50 rounded-md py-4 px-3 border border-borderColor"
          >
            <Package className="text-textGrey h-8 w-8 mb-2 border border-[#6F6F6F] rounded-md p-2 sm:h-10 sm:w-10 md:h-12 md:w-12" />
            <div>
              <p className="text-xs sm:text-sm text-textGrey">{metric.title}</p>
              <p className="text:sm md:text-lg font-semibold">{metric.value}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ContractOverview;
